import { OverlayModule } from '@angular/cdk/overlay';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { ButtonTapDirective } from 'core/directives/button-tap.directive';

import { MediaIfDirective } from '../../directives/media-if.directive';
import { OnInitDirective } from '../../directives/on-init.directive';
import { IconsModule } from '../icons/icons.module';
import { InputModule } from '../input/input.module';
import { DropdownComponent } from './dropdown.component';
import { AnchorDirective } from './dropdown-anchor.directive';
import { OverlayChildDirective } from './dropdown-child.directive';
import { MenuItemDirective } from './dropdown-close.directive';
import { DropdownSelectComponent } from './dropdown-select.component';
import { OverlayHostComponent } from './overlay-host.component';
import { SelectItemDirective } from './select-item.directive';

const exportedDeclarations = [
  SelectItemDirective,
  DropdownComponent,
  OverlayHostComponent,
  MenuItemDirective,
  AnchorDirective,
  DropdownSelectComponent,
  OverlayChildDirective,
];

@NgModule({
  imports: [
    CommonModule,
    MediaIfDirective,
    OnInitDirective,
    OverlayModule,
    IconsModule,
    ReactiveFormsModule,
    ButtonTapDirective,
    InputModule,
  ],
  declarations: exportedDeclarations,
  exports: exportedDeclarations,
})
export class DropdownModule {}
